<template>
  <div
    v-if="visible"
    class="in-line-popup__overlay"
    :style="{ zIndex }"
    @click.self="$emit('close')"
  >
    <section
      :class="['in-line-popup', isPC ? 'is-pc' : 'is-h5']"
      role="dialog"
      aria-modal="true"
      aria-label="You're in line"
    >
      <img
        class="in-line-popup__header"
        :src="baseballSuccessHeaderSrc"
        alt=""
      />
      <div class="in-line-popup__body">
        <div class="in-line-popup__copy">
          <img
            class="in-line-popup__title-image"
            :src="titleInLineSrc"
            alt="You're in line"
          />
          <p class="in-line-popup__text">
            High traffic! Your reward is processing.
            Results will be ready in about 15 seconds.
            Refresh and check My Prize Haul shortly.
          </p>
        </div>
        <button
          type="button"
          class="in-line-popup__btn"
          @click="$emit('close')"
        >
          Got it
        </button>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import baseballSuccessHeaderSrc from '../assets/baseball-success-header.png';
import titleInLineSrc from '../assets/title-in-line.png';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    key: "visible",
    required: true,
    type: Boolean
  },
  isPC: {
    key: "isPC",
    required: true,
    type: Boolean
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useZIndex,
    useTeleport
  } = (require('@fegobull/webapi') as any).use;
  useTeleport(document.body);
  const zIndex = useZIndex();
  return {
    baseballSuccessHeaderSrc,
    titleInLineSrc,
    zIndex
  };
};
export default __sfc_main;
</script>

<style scoped>
.in-line-popup__overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  font-family: BR Hendrix, Arial, sans-serif;
}

.in-line-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  background: #ffffff;
}

.in-line-popup__header {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.in-line-popup__body,
.in-line-popup__copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.in-line-popup__title-image {
  display: block;
  width: auto;
  max-width: 100%;
  margin: 0;
}

.in-line-popup__text {
  margin: 0;
  color: #525252;
  font-weight: 400;
  line-height: 1.35;
  text-align: center;
}

.in-line-popup__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0;
  border: none;
  background: #ff6900;
  color: #ffffff;
  font-family: BR Hendrix, Arial, sans-serif;
  font-weight: 600;
  cursor: pointer;
}

/* H5:视觉稿 100px = 1rem */
.in-line-popup.is-h5 {
  width: 6.3rem;
  border-radius: 0.4rem;
}

.in-line-popup.is-h5 .in-line-popup__header {
  height: 3.66rem;
}

.in-line-popup.is-h5 .in-line-popup__body {
  width: 100%;
  padding: 0.38rem 0.4rem 0.4rem;
  gap: 0.42rem;
}

.in-line-popup.is-h5 .in-line-popup__copy {
  width: 5.6rem;
  gap: 0.28rem;
}

.in-line-popup.is-h5 .in-line-popup__title-image {
  height: 0.66rem;
}

.in-line-popup.is-h5 .in-line-popup__text {
  font-size: 0.3rem;
}

.in-line-popup.is-h5 .in-line-popup__btn {
  width: 5rem;
  height: 0.9rem;
  font-size: 0.32rem;
  border-radius: 0.45rem;
}

.in-line-popup.is-pc {
  width: 420px;
  border-radius: 24px;
}

.in-line-popup.is-pc .in-line-popup__header {
  height: 244px;
}

.in-line-popup.is-pc .in-line-popup__body {
  width: 100%;
  padding: 25px 28px 28px;
  gap: 24px;
}

.in-line-popup.is-pc .in-line-popup__copy {
  gap: 16px;
}

.in-line-popup.is-pc .in-line-popup__title-image {
  height: 54px;
}

.in-line-popup.is-pc .in-line-popup__text {
  font-size: 18px;
}

.in-line-popup.is-pc .in-line-popup__btn {
  width: 320px;
  height: 56px;
  border-radius: 28px;
  font-size: 20px;
}
</style>
